/** Trigger a client-side download of text content (CSV/JSON exports). */
export function downloadText(filename: string, text: string, mime = 'application/json'): void {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Read a File as text (for Import). */
export function readFileText(file: File): Promise<string> {
  return file.text();
}

export function dateStamp(): string {
  return new Date().toISOString().slice(0, 10);
}
